import { render } from "./ClientServerInfo.vue?vue&type=template&id=4a99eb3c&scoped=true"
import script from "./ClientServerInfo.vue?vue&type=script&lang=js"
export * from "./ClientServerInfo.vue?vue&type=script&lang=js"

import "./ClientServerInfo.vue?vue&type=style&index=0&id=4a99eb3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a99eb3c"]])

export default __exports__